import { sem as semOrig } from "@repo/telemetry";

export { logs, traces, otel, SeverityNumber } from "@repo/telemetry";

export const sem = {
    ...semOrig,
    ATTR_LANGSMITH_SPAN_KIND: "langsmith.span.kind",
    ATTR_LANGSMITH_SPAN_TAGS: "langsmith.span.tags",
    ATTR_LANGSMITH_METADATA: (name: string) => `langsmith.metadata.${name}`,
    ATTR_LANGSMITH_METADATA_LC_HUB_REPO: "langsmith.metadata.lc_hub_repo",
    ATTR_LANGSMITH_INPUT: "input.value",
    ATTR_LANGSMITH_OUTPUT: "output.value",
    // from https://opentelemetry.io/docs/specs/semconv/attributes-registry/gen-ai/
    ATTR_GEN_AI_AGENT_DESCRIPTION: "gen_ai.agent.description",
    ATTR_GEN_AI_AGENT_ID: "gen_ai.agent.id",
    ATTR_GEN_AI_AGENT_NAME: "gen_ai.agent.name",
    ATTR_GEN_AI_OUTPUT_TYPE: "gen_ai.output.type",
};
